import { IconLock } from '@tabler/icons-react';
import { Button } from './ui/Button.js';

/**
 * Full-screen block shown when the agency has been suspended by a super-admin
 * (the backend returns 403 ACCOUNT_SUSPENDED on every request). Reuses the
 * billing reactivate-screen layout. No self-service action — the agency must
 * contact support. "Reload" lets a just-reactivated user back in (the in-memory
 * suspended flag resets on reload, and the first request then succeeds).
 */
export function SuspendedScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-cream p-6">
      <div className="w-full max-w-md text-center">
        <div className="mx-auto mb-5 flex h-12 w-12 items-center justify-center rounded-full bg-navy">
          <IconLock size={22} className="text-gold-soft" />
        </div>
        <h1 className="font-serif text-2xl text-ink tracking-tight mb-2">Account suspended</h1>
        <p className="text-sm text-muted mb-7">
          Your agency’s access has been suspended. Please contact support to resolve this.
        </p>
        <Button variant="secondary" className="w-full" onClick={() => window.location.reload()}>
          Reload
        </Button>
      </div>
    </div>
  );
}
